import { Container } from "../Container";

interface IFooterLinkProps {
  title: string;
  href: string;
}

function FooterLink(props: IFooterLinkProps) {
  return (
    <a href={props.href} target="_blank" className="no-underline m-[0]">
      {props.title}
    </a>
  );
}

interface IFooterLogoProps {
  logo: string;
  href: string;
}

function FooterLogo(props: IFooterLogoProps) {
  return (
    <a
      href={props.href}
      target="_blank"
      className={`h-[24px] w-[24px] bg-contain bg-no-repeat bg-center ${props.logo}`}
    />
  );
}

export function Footer(): JSX.Element {
  return (
    <div className=" bg-background-light border-t border-ampol-black-20 py-m">
      <Container className="h-full">
        <div className="flex flex-col w-full items-center mobile:flex-row mobile:justify-between">
          <ul className="p-[0] flex flex-col items-center mobile:flex-row list-none gap-xxs mobile:gap-m">
            <FooterLink
              title="Privacy Policy"
              href="https://www.ampol.com.au/privacy-policy"
            />
            <FooterLink
              title="Privacy Collection Statement"
              href="https://ampcharge.ampol.com.au/policies/privacy-collection-statement"
            />
            <FooterLink
              title="Terms of Use"
              href="https://ampcharge.ampol.com.au/policies/driver-portal-terms-and-conditions"
            />
          </ul>

          <ul className="p-[0] flex justify-between w-full mobile:justify-normal mobile:space-x-m mobile:w-auto list-none">
            <FooterLogo logo="bg-icon-facebook" href="https://www.facebook.com/AmpolAustralia/" />
            <FooterLogo logo="bg-icon-youtube" href="https://www.youtube.com/channel/UCUBpu03Fk2TddHtTmzynOOw" />
            <FooterLogo logo="bg-icon-tiktok" href="https://tiktok.com/@ampolaustralia" />
            <FooterLogo logo="bg-icon-linked-in" href="https://www.linkedin.com/company/ampol-australia/" />
            <FooterLogo logo="bg-icon-instagram" href="https://www.instagram.com/ampolaustralia/" />
          </ul>
        </div>
      </Container>
    </div>
  );
}
